import { SponsoredPostData } from "../body/desktop-body.component/right-sidebar/right-sidebar.component";
import { AssetFile } from "../manifest/models/asset.models";
import { Author, LeaderboardAuthor } from "../manifest/models/author.models";
import { Shortcut } from "../manifest/models/sidebar.models";
import { randomNumber } from "../utils/randomization";
import { StimuliBank } from "./stimuli.bank";
import { AuthorGenerator } from "./user_data/author.generator";

export interface LeaderboardConstraints {
  enabled: boolean;
  min_points: number;
  max_points: number;
}

export interface SidebarStimuli {
  sponsored: SponsoredPostData[];
  authors: Author[];
  avatars: AssetFile[];
  shortcuts: Shortcut[];
  showContacts?: boolean;
  leaderboard?: LeaderboardConstraints;
}

export class SidebarGenerator {
  generate(stimuli: StimuliBank): SidebarContent {
    const sidebar = stimuli.sidebar;

    if (sidebar == null) {
      throw new Error("No sidebar stimuli provided!");
    }

    return {
      sponsored: sidebar.sponsored[0],
      shortcuts: sidebar.shortcuts,
      birthdays: this.generateBirthdayList(sidebar),
      contacts: this.generateContactList(sidebar),
      onlineUsers: this.generateOnlineUsers(sidebar),
      showContacts: sidebar.showContacts ?? true,
      leaderboard: this.generateLeaderboardList(sidebar),
    };
  }

  generateOnlineUsers(stimuli: SidebarStimuli): Author[] {
    const generator = new AuthorGenerator(stimuli.authors);
    return [
      generator.getNextObject(),
      generator.getNextObject(),
      generator.getNextObject(),
      generator.getNextObject(),
    ];
  }

  generateBirthdayList(stimuli: SidebarStimuli): Author[] {
    const generator = new AuthorGenerator(stimuli.authors);
    return [generator.getNextObject(), generator.getNextObject()];
  }

  generateContactList(stimuli: SidebarStimuli): Author[] {
    const numberOfContacts = randomNumber(5, 10);
    const contacts = [];
    const authorGen = new AuthorGenerator(stimuli.authors);

    for (let i = 0; i < numberOfContacts; i++) {
      contacts.push({
        ...authorGen.getNextObject(),
      });
    }

    return contacts;
  }

  generateLeaderboardList(
    stimuli: SidebarStimuli,
  ): LeaderboardAuthor[] | undefined {
    if (!stimuli.leaderboard?.enabled) return undefined;

    const numberOfContacts = randomNumber(5, 10);
    const leaderboard: LeaderboardAuthor[] = [];
    const authorGen = new AuthorGenerator(stimuli.authors);
    const min = stimuli.leaderboard!.min_points;
    const max = stimuli.leaderboard!.max_points;

    for (let i = 0; i < numberOfContacts; i++) {
      leaderboard.push({
        ...authorGen.getNextObject(),
        points: randomNumber(min, max),
      });
    }

    return leaderboard.sort((a, b) => b.points - a.points);
  }
}

export interface SidebarContent {
  sponsored: SponsoredPostData;
  birthdays: Author[];
  contacts: Author[];
  shortcuts: Shortcut[];
  onlineUsers: Author[];
  showContacts: boolean;
  leaderboard?: LeaderboardAuthor[];
}
